export const CDN_BASE_URL = `https://prod-cdn-candy-hoover.mktg-port.he.services/hoover/static/custom`;
export const NEW_LINES = ["12", "13", "14", "15", "241", "777", "888", "666"];
export const social = ["facebook", "linkedin", "instagram", "vk", "twitter", "mail", "link"];
